import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['statusCell']

  static values = {
    refreshInterval: { type: Number, default: 10000 },
  }

  connect() {
    this.initialStatuses = this.statuses

    if (!this.hasPendingStatuses(this.initialStatuses)) return

    this.timer = window.setInterval(() => {
      this.checkForStatusUpdates()
    }, this.refreshIntervalValue)
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  get statuses() {
    return this.statusCellTargets.map((cell) => cell.textContent.trim())
  }

  hasPendingStatuses(statuses) {
    return statuses.some((status) => {
      const normalized = status.toLowerCase()
      return !['completed', 'failed', 'cancelled', 'canceled'].includes(
        normalized,
      )
    })
  }

  checkForStatusUpdates() {
    fetch(window.location.href, {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    })
      .then((response) => response.text())
      .then((html) => {
        const nextDocument = new DOMParser().parseFromString(html, 'text/html')
        const nextStatuses = Array.from(
          nextDocument.querySelectorAll(
            '[data-hr-portal-activity-status-target="statusCell"]',
          ),
        ).map((cell) => cell.textContent.trim())

        if (nextStatuses.length !== this.initialStatuses.length) {
          window.location.reload()
          return null
        }

        const hasStatusChanged = nextStatuses.some(
          (status, index) => status !== this.initialStatuses[index],
        )

        if (hasStatusChanged) {
          window.location.reload()
          return null
        }

        if (!this.hasPendingStatuses(nextStatuses) && this.timer) {
          window.clearInterval(this.timer)
          this.timer = null
          return null
        }

        return null
      })
      .catch(() => {})
  }
}
